import { useState } from "react";
import { Button } from "@/components/ui/button";
import { Label } from "@/components/ui/label";
import { TestTube } from "lucide-react";
import { notificationService } from "@/services/notificationService";
import { toast } from "@/hooks/use-toast";

interface TestNotificationPanelProps {
  userId: string;
  isVisible: boolean;
}

const TestNotificationPanel = ({ userId, isVisible }: TestNotificationPanelProps) => {
  const [testLoading, setTestLoading] = useState(false);

  const sendTestNotification = async () => {
    setTestLoading(true);
    try {
      const success = await notificationService.sendSystemNotification(
        userId,
        "🧪 Test Notification",
        "This is a test notification from your app settings!"
      );

      if (success) {
        toast({
          title: "Test sent",
          description: "Test notification has been sent to your device.",
        });
      } else {
        toast({
          title: "Test failed",
          description: "Failed to send test notification.",
          variant: "destructive",
        });
      }
    } catch (error) {
      console.error('Test notification error:', error);
      toast({
        title: "Error",
        description: "An error occurred while sending the test notification.",
        variant: "destructive",
      });
    } finally {
      setTestLoading(false);
    }
  };

  if (!isVisible) return null;

  return (
    <div className="flex items-center justify-between p-4 bg-muted rounded-lg">
      <div>
        <Label className="text-sm font-medium">Test Notifications</Label>
        <p className="text-xs text-muted-foreground">Send a test notification to verify everything works</p>
      </div>
      <Button 
        onClick={sendTestNotification} 
        size="sm" 
        variant="outline"
        disabled={testLoading}
      >
        <TestTube className="w-4 h-4 mr-2" />
        {testLoading ? "Sending..." : "Send Test"}
      </Button>
    </div>
  );
};

export default TestNotificationPanel;